import { render, staticRenderFns } from "./nav-left.vue?vue&type=template&id=0c834712&"
import script from "./nav-left.vue?vue&type=script&lang=ts&"
export * from "./nav-left.vue?vue&type=script&lang=ts&"
import style0 from "./nav-left.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports